<template>
  <div>
    <title-bar-back :title="$route.query.key" @back="back">
      <div>
        <div
          v-if="$route.query.key === '编辑收货人'"
          class="title_right font14 font_weight400 colo087 line_height_20"
          @click="deleteAddress"
        >
          删除
        </div>
        <div v-else class="tit_right"></div>
      </div>
    </title-bar-back>
    <div class="address_con">
      <div class="item_l border_bottom1px">
        <van-field
          v-model="valueName"
          label="收货人"
          placeholder="请填写收货人姓名"
        />
      </div>
      <div class="item_l border_bottom1px">
        <van-field
          v-model="valuePhone"
          type="number"
          label="手机号码"
          placeholder="手机号码"
        />
      </div>
      <div class="item_l l_flex border_bottom1px" @click="showSelect">
        <van-field
          :disabled="true"
          v-model="valueAddress"
          label="所在区域"
          placeholder="选择所在省份、城市、区县"
        />
        <img
          src="@/assets/common/icon_back_b87_24@2x.png"
          alt=""
          class="goAddress"
        />
      </div>
      <div class="item_l border_bottom1px">
        <van-field
          v-model="valueAddDet"
          label="详细地址"
          placeholder="请输入街道、楼牌号等详细地址"
        />
      </div>
      <div
        class="default_icon font12 font_weight400 colo055 line_height_17 text_left"
        @click="defaultClick"
      >
        <img :src="select ? selectDefault : unSelectDefault" alt="" />
        <span>设为默认收货地址</span>
      </div>
      <div
        class="save_btn font_weight500 font14 colof line_height_20"
        @click="saveBtn"
      >
        保存
      </div>
    </div>
    <!-- 地址选择器 -->
    <div class="font0">
      <address-select-sheet
        v-if="showAddressSelectSheet"
        @closeSheet="closeSheet"
        @getSelectAddress="getSelectAddress"
      />
    </div>
  </div>
</template>

<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
const AddressSelectSheet = () =>
  import("../../product/detail/components/AddressSelectSheet").then(
    m => m.default || m
  );
export default {
  name: "AddEditAddress",
  components: {
    TitleBarBack,
    AddressSelectSheet
  },
  data() {
    return {
      valueName: "",
      valuePhone: "",
      valueAddress: "",
      valueAddDet: "",
      showAddressSelectSheet: false,
      selectDefault: require("@/assets/login/select@2x.png"),
      unSelectDefault: require("@/assets/login/unselect@2x.png"),
      select: false,
      province: "",
      city: "",
      district: ""
    };
  },
  computed: {
    getAddressById() {
      return this.$store.getters.getAddressById;
    }
  },
  created() {
    if (this.$route.query.id) {
      this.getdata();
    }
  },
  // mounted() {
  //   console.log(!this.valuePhone.trim());
  // },
  methods: {
    // 编辑的时候查询地址信息
    getdata() {
      // getCartList
      const params = { id: this.$route.query.id };
      this.$store
        .dispatch("mine/getAddressById", { params })
        .then(res => {
          this.valueName = res.name;
          this.valuePhone = res.phone;
          this.valueAddDet = res.addressLine;
          this.valueAddress =
            res.province + " " + res.city + " " + res.district;
          this.select = res.isDefault === 1 ? true : false;
          this.province = res.province;
          this.city = res.city;
          this.district = res.district;
        })
        .catch(() => {});
    },
    back() {
      this.$router.back();
    },
    // 删除地址
    deleteAddress() {
      // deleteAddress
      this.$dialog
        .confirm({
          // title: "暂停配送",
          message: "确定删除该地址吗？",
          confirmButtonText: "确定",
          confirmButtonColor: "#DD9132"
        })
        .then(() => {
          this.$store
            .dispatch("mine/deleteAddress", {
              params: { id: this.$route.query.id }
            })
            .then(() => {
              this.$router.back(-1);
              localStorage.removeItem("pur-address");
              localStorage.removeItem("exchange-milk-pur-address");
              localStorage.removeItem("exchange-milk-plan-one-address");
              localStorage.removeItem("exchange-milk-plan-all-address");
            })
            .catch(() => {});
        })
        .catch(() => {
          // console.log(123)
        });
    },
    saveBtn() {
      // 添加 addAddress
      // 修改 updateAddress
      const regs = /^(1[3456789])\d{9}$/;
      if (!this.valueName.trim()) {
        this.$toast("请填写收货人姓名");
        return;
      }
      if (!this.valueName.trim()) {
        this.$toast("请填写收货人姓名");
        return;
      }
      if (!this.valuePhone.trim() || !regs.test(this.valuePhone.trim())) {
        this.$toast("请填写正确的收货人手机号码");
        return;
      }
      if (!this.province || !this.city || !this.district) {
        this.$toast("请选择收货人所在区域");
        return;
      }
      if (!this.valueAddDet.trim()) {
        this.$toast("请填写收货人详细地址");
        return;
      }
      const params = {
        name: this.valueName.trim(),
        phone: this.valuePhone.trim(),
        province: this.province,
        city: this.city,
        district: this.district,
        addressLine: this.valueAddDet.trim(),
        isDefault: this.select ? 1 : 0
      };
      let url = "mine/addAddress";
      if (this.$route.query.id) {
        params.id = this.$route.query.id;
        url = "mine/updateAddress";
      }
      this.$store
        .dispatch(url, { params })
        .then(res => {
          if (this.$route.query.previousPage === "pur") {
            console.log(111);
            localStorage.setItem("pur-address", JSON.stringify(res));
            this.$router.go(-2);
            return;
          }
          if (this.$route.query.previousPage === "exchangeMilkPur") {
            console.log(2222);
            localStorage.setItem(
              "exchange-milk-pur-address",
              JSON.stringify(res)
            );
            this.$router.go(-2);
            return;
          }
          if (this.$route.query.previousPage === "milkPlan") {
            console.log(33333);
            if (this.$route.query.switchPur === "one") {
              localStorage.setItem(
                "exchange-milk-plan-one-address",
                JSON.stringify(res)
              );
              localStorage.setItem(
                "exchange-milk-plan-one-parcelId",
                this.$route.query.parcelId
              );
            } else {
              localStorage.setItem(
                "exchange-milk-plan-all-address",
                JSON.stringify(res)
              );
            }
            this.$router.go(-2);
            return;
          }
          console.log(4444);
          this.$router.back(-1);
        })
        .catch(() => {});
    },
    // 设置默认
    defaultClick() {
      this.select = !this.select;
    },
    // 显示选择器
    showSelect() {
      this.showAddressSelectSheet = true;
    },
    // 获取选择地址
    getSelectAddress(address) {
      // console.log(address, "获取用户选择的地址");
      this.valueAddress = "";
      address.forEach(item => {
        this.valueAddress = this.valueAddress + item.areaName + "  ";
      });
      this.province = address[0].areaName;
      this.city = address[1].areaName;
      this.district = address[2].areaName;
    },
    closeSheet() {
      this.showAddressSelectSheet = false;
    }
  }
};
</script>

<style lang="less" scoped>
.title_right {
  // width: 36px;
  margin-top: 12px;
}
.tit_right {
  width: 36px;
}
.address_con {
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  background: #fff;
  .l_flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item_l {
    margin-left: 12px;
    .goAddress {
      width: 24px;
      height: 24px;
    }
    ::v-deep .van-cell {
      margin-right: 0;
      padding-left: 0;
      color: rgba(0, 0, 0, 0.87);
    }
    ::v-deep .van-field__label {
      margin-right: 0;
      color: rgba(0, 0, 0, 0.87);
    }
    ::v-deep .van-field__control {
      color: rgba(0, 0, 0, 0.4);
      -webkit-text-fill-color: rgba(0, 0, 0, 0.4);
    }
  }
  .default_icon {
    margin: 60px 0 0 12px;
    img {
      width: 18px;
      margin-right: 2px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
  }
  .save_btn {
    margin: 13px 12px 0;
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    border-radius: 2px;
    padding: 14px 0;
  }
}
</style>
